module.exports = __webpack_public_path__ + "img/yue.b9613fc0.jpg";